export enum QuickPickerNames {
  Today = 'TODAY',
  TwentyFourHours = '24 HOURS',
  FortyEightHours = '48 HOURS',
  SeventyTwoHours = '72 HOURS',
  SevenDays = '7 DAYS',
  OneMonth = '1 MONTH',
  TwoMonths = '2 MONTHS',
  ThreeMonths = '3 MONTHS',
  SixMonths = '6 MONTHS',
  All = 'All',
  Custom = '',
}
